export default __webpack_public_path__ + "static/media/prag_banner.fb9cba96.png";